import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { from } from 'rxjs';
import { DEFAULT_GET_LIMIT } from '../shared/constants/operationals';
import { Store } from './stores.service';

export const SELLER_INVITATIONS_API_NAME: string = 'seller-invitations';
export const SELLER_INVITATIONS_API_ENDPOINT: string = environment.API_BASE_PATH + '/seller-invitation';
@Injectable({
  providedIn: 'root',
})
export class SellerInvitationsService {
  listPendingInvitations(list_params: ListPendingInvitationsParams) {
    const api_name: string = SELLER_INVITATIONS_API_NAME;
    const path: string = '/pending';

    let query_string_params: any = {
      cursor: list_params?.cursor || null,
      limit: list_params?.limit || DEFAULT_GET_LIMIT,
    };
    if (list_params?.company_id) query_string_params['company_id'] = list_params.company_id;
    if (list_params?.company_business_name)
      query_string_params['company_business_name'] = list_params.company_business_name;
    if (list_params?.sender_email) query_string_params['sender_email'] = list_params.sender_email;
    if (list_params?.recipient_email) query_string_params['recipient_email'] = list_params.recipient_email;
    if (list_params?.store_id) query_string_params['store_id'] = list_params.store_id;

    const init = { response: true, queryStringParameters: query_string_params };
    return from(API.get(api_name, path, init));
  }
}
export interface ListPendingInvitationsParams {
  company_id?: string;
  company_business_name?: string;
  sender_email?: string;
  recipient_email?: string;
  store_id?: string;

  cursor?: string | null;
  limit?: number;
}

export interface SellerInvitation {
  sender_email?: string;
  recipient_email?: string;
  company_id?: string;
  company_business_name?: string;
  stores?: Store[];
}

export enum SellerInvitationRole {
  admin = 'admin',
  analyst = 'analyst',
  store_manager = 'store_manager',
  store_seller = 'store_seller',
}
